// Base URL
export const BASE_URL =
`${process.env.REACT_APP_API_BASE_URL || "https://api.shrigaar.com"}/api/v1`;

// Collections endpoints
export const COLLECTION_ENDPOINTS = {
  LIST: "/shrigar/collections/list/api52",
};

// Products endpoints
export const PRODUCT_ENDPOINTS = {
  LIST: "/shrigar/Collections/products/list/api56",
};

// Categories endpoints
export const GET_CATEGORIES = {
  LIST: "/shrigar/getCategories/list/api54",
};